import accordion from '@primevue/themes/aura/accordion';
import autocomplete from '@primevue/themes/aura/autocomplete';
import avatar from '@primevue/themes/aura/avatar';
import badge from '@primevue/themes/aura/badge';
import base from '@primevue/themes/aura/base';
import blockui from '@primevue/themes/aura/blockui';
import breadcrumb from '@primevue/themes/aura/breadcrumb';
import button from '@primevue/themes/aura/button';
import card from '@primevue/themes/aura/card';
import carousel from '@primevue/themes/aura/carousel';
import cascadeselect from '@primevue/themes/aura/cascadeselect';
import checkbox from '@primevue/themes/aura/checkbox';
import chip from '@primevue/themes/aura/chip';
import colorpicker from '@primevue/themes/aura/colorpicker';
import confirmdialog from '@primevue/themes/aura/confirmdialog';
import confirmpopup from '@primevue/themes/aura/confirmpopup';
import contextmenu from '@primevue/themes/aura/contextmenu';
import datatable from '@primevue/themes/aura/datatable';
import dataview from '@primevue/themes/aura/dataview';
import datepicker from '@primevue/themes/aura/datepicker';
import dialog from '@primevue/themes/aura/dialog';
import divider from '@primevue/themes/aura/divider';
import dock from '@primevue/themes/aura/dock';
import drawer from '@primevue/themes/aura/drawer';
import editor from '@primevue/themes/aura/editor';
import fieldset from '@primevue/themes/aura/fieldset';
import fileupload from '@primevue/themes/aura/fileupload';
import floatlabel from '@primevue/themes/aura/floatlabel';
import galleria from '@primevue/themes/aura/galleria';
import iconfield from '@primevue/themes/aura/iconfield';
import iftalabel from '@primevue/themes/aura/iftalabel';
import image from '@primevue/themes/aura/image';
import imagecompare from '@primevue/themes/aura/imagecompare';
import inlinemessage from '@primevue/themes/aura/inlinemessage';
import inplace from '@primevue/themes/aura/inplace';
import inputchips from '@primevue/themes/aura/inputchips';
import inputgroup from '@primevue/themes/aura/inputgroup';
import inputnumber from '@primevue/themes/aura/inputnumber';
import inputtext from '@primevue/themes/aura/inputtext';
import knob from '@primevue/themes/aura/knob';
import listbox from '@primevue/themes/aura/listbox';
import megamenu from '@primevue/themes/aura/megamenu';
import menu from '@primevue/themes/aura/menu';
import menubar from '@primevue/themes/aura/menubar';
import message from '@primevue/themes/aura/message';
import metergroup from '@primevue/themes/aura/metergroup';
import multiselect from '@primevue/themes/aura/multiselect';
import orderlist from '@primevue/themes/aura/orderlist';
import organizationchart from '@primevue/themes/aura/organizationchart';
import overlaybadge from '@primevue/themes/aura/overlaybadge';
import paginator from '@primevue/themes/aura/paginator';
import panel from '@primevue/themes/aura/panel';
import panelmenu from '@primevue/themes/aura/panelmenu';
import password from '@primevue/themes/aura/password';
import picklist from '@primevue/themes/aura/picklist';
import popover from '@primevue/themes/aura/popover';
import progressbar from '@primevue/themes/aura/progressbar';
import progressspinner from '@primevue/themes/aura/progressspinner';
import radiobutton from '@primevue/themes/aura/radiobutton';
import rating from '@primevue/themes/aura/rating';
import ripple from '@primevue/themes/aura/ripple';
import scrollpanel from '@primevue/themes/aura/scrollpanel';
import select from '@primevue/themes/aura/select';
import selectbutton from '@primevue/themes/aura/selectbutton';
import skeleton from '@primevue/themes/aura/skeleton';
import slider from '@primevue/themes/aura/slider';
import speeddial from '@primevue/themes/aura/speeddial';
import splitbutton from '@primevue/themes/aura/splitbutton';
import splitter from '@primevue/themes/aura/splitter';
import stepper from '@primevue/themes/aura/stepper';
import steps from '@primevue/themes/aura/steps';
import tabmenu from '@primevue/themes/aura/tabmenu';
import tabs from '@primevue/themes/aura/tabs';
import tabview from '@primevue/themes/aura/tabview';
import tag from '@primevue/themes/aura/tag';
import terminal from '@primevue/themes/aura/terminal';
import textarea from '@primevue/themes/aura/textarea';
import tieredmenu from '@primevue/themes/aura/tieredmenu';
import timeline from '@primevue/themes/aura/timeline';
import toast from '@primevue/themes/aura/toast';
import togglebutton from '@primevue/themes/aura/togglebutton';
import toggleswitch from '@primevue/themes/aura/toggleswitch';
import toolbar from '@primevue/themes/aura/toolbar';
import tooltip from '@primevue/themes/aura/tooltip';
import tree from '@primevue/themes/aura/tree';
import treeselect from '@primevue/themes/aura/treeselect';
import treetable from '@primevue/themes/aura/treetable';
import virtualscroller from '@primevue/themes/aura/virtualscroller';

export default {
    ...base,
    components: {
        accordion,
        autocomplete,
        avatar,
        badge,
        blockui,
        breadcrumb,
        button,
        datepicker,
        card,
        carousel,
        cascadeselect,
        checkbox,
        chip,
        colorpicker,
        confirmdialog,
        confirmpopup,
        contextmenu,
        dataview,
        datatable,
        dialog,
        divider,
        dock,
        drawer,
        editor,
        fieldset,
        fileupload,
        iftalabel,
        floatlabel,
        galleria,
        iconfield,
        image,
        imagecompare,
        inlinemessage,
        inplace,
        inputchips,
        inputgroup,
        inputnumber,
        inputtext,
        knob,
        listbox,
        megamenu,
        menu,
        menubar,
        message,
        metergroup,
        multiselect,
        orderlist,
        organizationchart,
        overlaybadge,
        popover,
        paginator,
        password,
        panel,
        panelmenu,
        picklist,
        progressbar,
        progressspinner,
        radiobutton,
        rating,
        scrollpanel,
        select,
        selectbutton,
        skeleton,
        slider,
        speeddial,
        splitter,
        splitbutton,
        stepper,
        steps,
        tabmenu,
        tabs,
        tabview,
        textarea,
        tieredmenu,
        tag,
        terminal,
        timeline,
        togglebutton,
        toggleswitch,
        tree,
        treeselect,
        treetable,
        toast,
        toolbar,
        virtualscroller
    },
    directives: {
        tooltip,
        ripple
    }
};
